// Mirror of internal/pkg/role/permissions.go in pickdrop_backend. Keep in sync.
export const PERMS = {
  RIDER_READ: 'rider.read',
  RIDER_WRITE: 'rider.write',
  RIDER_APPROVE: 'rider.approve',
  RIDER_SUSPEND: 'rider.suspend',
  REQUEST_READ: 'request.read',
  REQUEST_WRITE: 'request.write',
  REQUEST_ASSIGN: 'request.assign',
  REQUEST_CANCEL: 'request.cancel',
  PRICING_READ: 'pricing.read',
  PRICING_WRITE: 'pricing.write',
  FINANCIAL_READ: 'financial.read',
  FINANCIAL_WRITE: 'financial.write',
  REFUND_ISSUE: 'refund.issue',
  BROADCAST_WRITE: 'broadcast.write',
  PROMO_WRITE: 'promo.write',
  ADMIN_WRITE: 'admin.write',
  ROLE_ASSIGN: 'role.assign',
  AUDIT_READ: 'audit.read',
};

export function hasPermission(user, perm) {
  if (!user || !Array.isArray(user.permissions)) return false;
  return user.permissions.includes(perm);
}
